(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.drawer-overlay');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartEmpty = document.querySelector('[data-cart-empty]');
  const cartTotalRow = document.querySelector('[data-cart-total-row]');
  const cartTotal = document.querySelector('[data-cart-total]');
  const cartStatus = document.querySelector('[data-cart-status]');
  const checkout = document.querySelector('.drawer-checkout');
  const stringsNode = document.querySelector('[data-theme-strings]');
  const strings = stringsNode ? JSON.parse(stringsNode.textContent) : {};
  const translated = (key, fallback, replacements = {}) => {
    let value = strings[key] || fallback;
    Object.entries(replacements).forEach(([token, replacement]) => {
      value = value.replaceAll(`__${token}__`, String(replacement));
    });
    return value;
  };

  // Display-only currencies. Shopify keeps the cart and checkout in EUR while
  // the storefront shows an indicative amount in the visitor's local currency.
  const displayCurrencyByCountry = {
    GB: 'GBP', PL: 'PLN', NO: 'NOK', RO: 'RON', DK: 'DKK', SE: 'SEK', FI: 'EUR'
  };
  const displayRateByCurrency = {
    EUR: 1, GBP: 0.86, PLN: 4.25, NOK: 11.8, RON: 5.07, DKK: 7.46, SEK: 11.1
  };
  const currentCountry = String(window.Shopify?.country || 'FR').toUpperCase();
  const displayCurrency = displayCurrencyByCountry[currentCountry] || 'EUR';
  const displayRate = displayRateByCurrency[displayCurrency] || 1;
  const currencyForCountry = (countryCode) => displayCurrencyByCountry[String(countryCode || '').toUpperCase()] || 'EUR';

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency',
    currency: displayCurrency
  }).format((Number(cents) / 100) * displayRate);

  const renderDisplayCurrencies = () => {
    document.querySelectorAll('[data-display-money][data-eur-cents]').forEach((node) => {
      node.textContent = money(node.dataset.eurCents);
    });
    document.querySelectorAll('[data-display-save][data-eur-cents]').forEach((node) => {
      node.textContent = String(node.dataset.displaySave || '__AMOUNT__')
        .replace('__AMOUNT__', money(node.dataset.eurCents));
    });

    const countrySelect = document.querySelector('.country-form [name="country_code"]');
    if (countrySelect) [...countrySelect.options].forEach((option) => {
      option.textContent = `${option.value} · ${currencyForCountry(option.value)}`;
    });

    const localizationSummary = document.querySelector('[data-localization-summary]');
    if (localizationSummary) {
      localizationSummary.textContent = localizationSummary.textContent.replace(/\b[A-Z]{3}\b/, displayCurrency);
    }
  };

  const escapeHtml = (value) => String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const setDrawerOpen = (open) => {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  };

  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    document.querySelectorAll('.cart-button').forEach((node) => {
      node.setAttribute('aria-label', translated('cartLabel', `Cart, ${cart.item_count}`, { COUNT: cart.item_count }));
    });

    if (!cartItems || !cartEmpty || !cartTotalRow || !checkout) return;
    const isEmpty = cart.item_count === 0;
    cartEmpty.hidden = !isEmpty;
    cartItems.hidden = isEmpty;
    cartTotalRow.hidden = isEmpty;
    checkout.hidden = isEmpty;

    if (isEmpty) {
      cartItems.innerHTML = '';
      return;
    }

    cartItems.innerHTML = cart.items.map((item) => `
      <div class="drawer-item">
        <div>${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" width="180" height="180">` : ''}</div>
        <p><b>${escapeHtml(item.product_title)}</b><small>${escapeHtml(item.variant_title)}</small><span>${item.quantity} × ${money(item.final_price)}</span></p>
        <button type="button" data-remove-line="${escapeHtml(item.key)}" aria-label="${escapeHtml(translated('remove', `Remove ${item.product_title}`, { PRODUCT: item.product_title }))}">−</button>
      </div>
    `).join('');
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
  };

  const refreshCart = async (open = false) => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(translated('loadError', 'Unable to load the cart.'));
    const cart = await response.json();
    renderCart(cart);
    if (open) setDrawerOpen(true);
    return cart;
  };

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('.cart-button');
    const closeButton = event.target.closest('[data-cart-close]');
    const removeButton = event.target.closest('[data-remove-line]');

    if (openButton) {
      event.preventDefault();
      try { await refreshCart(true); } catch { setDrawerOpen(true); }
    }
    if (closeButton) {
      event.preventDefault();
      setDrawerOpen(false);
    }
    if (removeButton) {
      removeButton.disabled = true;
      if (cartStatus) cartStatus.textContent = translated('updating', 'Updating cart…');
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: removeButton.dataset.removeLine, quantity: 0 })
        });
        if (!response.ok) throw new Error(translated('updateError', 'The update failed.'));
        renderCart(await response.json());
        if (cartStatus) cartStatus.textContent = '';
      } catch (error) {
        if (cartStatus) cartStatus.textContent = error.message;
        removeButton.disabled = false;
      }
    }
  });

  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = !mobileMenu.classList.contains('is-open');
      mobileMenu.classList.toggle('is-open', open);
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? menuButton.dataset.labelClose : menuButton.dataset.labelOpen);
    });
      mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      mobileMenu.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', menuButton.dataset.labelOpen);
    }));
  }

  const funnel = document.querySelector('[data-sales-funnel]');
  if (funnel) {
    const variantsNode = document.querySelector('[data-product-variants]');
    const galleriesNode = document.querySelector('[data-product-galleries]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const galleries = galleriesNode ? JSON.parse(galleriesNode.textContent) : {};
    const form = funnel.querySelector('[data-product-form]');
    const variantInput = funnel.querySelector('[data-variant-id]');
    const addButton = form && form.querySelector('.primary-cta');
    const addLabel = funnel.querySelector('[data-add-label]');
    const colorLabel = funnel.querySelector('[data-color-label]');
    const galleryMain = funnel.querySelector('[data-gallery-main]');
    const galleryThumbs = funnel.querySelector('[data-gallery-thumbs]');
    let selectedSize = '38';
    let selectedColor = 'Chestnut';
    let selectedGallery = galleries[selectedColor] || [];

    const selectGalleryImage = (index) => {
      const image = selectedGallery[index] || selectedGallery[0];
      if (!image || !galleryMain) return;
      galleryMain.style.opacity = '0';
      window.setTimeout(() => {
        galleryMain.src = image.src;
        galleryMain.alt = image.alt;
        galleryMain.style.opacity = '1';
      }, 120);
      if (galleryThumbs) galleryThumbs.querySelectorAll('button').forEach((button, buttonIndex) => button.classList.toggle('active', buttonIndex === index));
    };

    const renderGallery = () => {
      selectedGallery = galleries[selectedColor] || [];
      if (!galleryThumbs) return;
      galleryThumbs.innerHTML = selectedGallery.map((image, index) => `
        <button type="button" data-gallery-index="${index}" class="${index === 0 ? 'active' : ''}" aria-label="${escapeHtml(translated('photo', `View photo ${index + 1}`, { NUMBER: index + 1 }))}">
          <img src="${escapeHtml(image.src)}" alt="" width="160" height="120">
        </button>
      `).join('');
      selectGalleryImage(0);
    };

    const syncVariant = () => {
      const variant = variants.find((item) => String(item.option1) === selectedSize && String(item.option2) === selectedColor);
      if (!variant || !variantInput || !addButton) return;
      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? translated('add', 'Add to cart') : translated('soldOut', 'Sold out');
    };

    funnel.querySelectorAll('[data-color]').forEach((button) => button.addEventListener('click', () => {
      selectedColor = button.dataset.color;
      funnel.querySelectorAll('[data-color]').forEach((item) => item.classList.toggle('active', item === button));
      if (colorLabel) colorLabel.textContent = button.dataset.colorLabel;
      renderGallery();
      syncVariant();
    }));

    funnel.querySelectorAll('[data-size]').forEach((button) => button.addEventListener('click', () => {
      selectedSize = button.dataset.size;
      funnel.querySelectorAll('[data-size]').forEach((item) => item.classList.toggle('active', item === button));
      syncVariant();
    }));

    if (galleryThumbs) {
      galleryThumbs.addEventListener('click', (event) => {
        const button = event.target.closest('[data-gallery-index]');
        if (button) selectGalleryImage(Number(button.dataset.galleryIndex));
      });
    }

    const sizeGuide = funnel.querySelector('[data-size-guide]');
    if (sizeGuide) sizeGuide.addEventListener('click', () => document.querySelector('#faq-tailles')?.scrollIntoView({ behavior: 'smooth' }));

    const steps = strings.steps || [
      ['Assembled boot', 'Slide to explore its construction.'],
      ['Protective upper', 'The soft suede receives a localized water-repellent treatment.'],
      ['17 mm lining', 'Double-faced sheepskin wraps around the foot.'],
      ['Underfoot comfort', '17 mm insole and flexible outsole.']
    ];
    const range = funnel.querySelector('[data-boot-range]');
    const scrubber = funnel.querySelector('.boot-scrubber');
    const progressLabel = funnel.querySelector('[data-progress-label]');
    const stepNumber = funnel.querySelector('[data-step-number]');
    const stepTitle = funnel.querySelector('[data-step-title]');
    const stepCopy = funnel.querySelector('[data-step-copy]');
    if (range) {
      range.addEventListener('input', () => {
        const value = Number(range.value);
        const step = Math.min(3, Math.floor(value / 26));
        if (scrubber) scrubber.style.setProperty('--progress', String(value / 100));
        if (progressLabel) progressLabel.textContent = `${value}%`;
        if (stepNumber) stepNumber.textContent = `0${step + 1}`;
        if (stepTitle) stepTitle.textContent = steps[step][0];
        if (stepCopy) stepCopy.textContent = steps[step][1];
      });
    }

    if (form) form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      const originalLabel = addLabel ? addLabel.textContent : '';
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = translated('adding', 'Adding…');
      if (cartStatus) cartStatus.textContent = '';
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const payload = await response.json();
          throw new Error(payload.description || translated('addError', 'Unable to add this variant.'));
        }
        await refreshCart(true);
        if (addLabel) addLabel.textContent = translated('added', 'Added to cart ✓');
        window.setTimeout(() => { if (addLabel) addLabel.textContent = originalLabel; }, 1400);
      } catch (error) {
        if (cartStatus) cartStatus.textContent = error.message;
        setDrawerOpen(true);
        if (addLabel) addLabel.textContent = originalLabel;
      } finally {
        syncVariant();
      }
    });

    renderGallery();
    syncVariant();
  }

  const enableAutomaticLocalization = () => {
    const manualPreferenceKey = 'maison-salome-localization-manual-v1';
    const automaticSessionKey = 'maison-salome-localization-auto-v1';
    const languageForms = [...document.querySelectorAll('.language-form')];
    const countryForm = document.querySelector('.country-form');
    const countrySelect = countryForm && countryForm.querySelector('[name="country_code"]');

    const safeStorage = (storage, method, key, value) => {
      try {
        return storage[method](key, value);
      } catch {
        return null;
      }
    };

    const rememberManualChoice = () => {
      safeStorage(window.localStorage, 'setItem', manualPreferenceKey, '1');
    };

    languageForms.forEach((form) => form.addEventListener('submit', rememberManualChoice));
    if (countrySelect) countrySelect.addEventListener('change', rememberManualChoice);

    if (safeStorage(window.localStorage, 'getItem', manualPreferenceKey)) return;
    if (safeStorage(window.sessionStorage, 'getItem', automaticSessionKey)) return;

    const availableLanguages = new Set(languageForms
      .map((form) => form.querySelector('[name="language_code"]')?.value)
      .filter(Boolean));
    const availableCountries = new Set(countrySelect
      ? [...countrySelect.options].map((option) => option.value)
      : []);
    if (!availableLanguages.size) return;

    const languageByCountry = {
      FR: 'fr', BE: 'fr', LU: 'fr', MC: 'fr',
      GB: 'en', IE: 'en', MT: 'en',
      PL: 'pl', NO: 'nb', RO: 'ro', SE: 'sv', DK: 'da', FI: 'fi'
    };
    const localePrefixes = new Set([...availableLanguages].map((language) => language.split('-')[0]));
    const firstPathSegment = window.location.pathname.split('/').filter(Boolean)[0] || '';
    const hasExplicitLanguagePath = localePrefixes.has(firstPathSegment);
    const currentLanguage = (document.documentElement.lang || 'fr').split('-')[0];
    const currentCountry = String(window.Shopify?.country || '').toUpperCase();

    fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('Country detection unavailable');
        return response.json();
      })
      .then((context) => {
        const detectedCountry = String(context?.detected_values?.country?.handle || '').toUpperCase();
        if (!detectedCountry) return;

        const mappedLanguage = languageByCountry[detectedCountry] || 'en';
        const targetLanguage = hasExplicitLanguagePath
          ? currentLanguage
          : (availableLanguages.has(mappedLanguage) ? mappedLanguage : currentLanguage);
        const targetCountry = availableCountries.has(detectedCountry) ? detectedCountry : currentCountry;

        safeStorage(window.sessionStorage, 'setItem', automaticSessionKey, '1');
        if (targetLanguage === currentLanguage && targetCountry === currentCountry) return;

        const localizationForm = document.createElement('form');
        localizationForm.method = 'post';
        localizationForm.action = '/localization';
        localizationForm.hidden = true;
        const fields = {
          form_type: 'localization',
          utf8: '✓',
          _method: 'put',
          return_to: `${window.location.pathname}${window.location.search}${window.location.hash}`,
          language_code: targetLanguage,
          country_code: targetCountry
        };
        Object.entries(fields).forEach(([name, value]) => {
          if (!value) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          localizationForm.appendChild(input);
        });
        document.body.appendChild(localizationForm);
        localizationForm.submit();
      })
      .catch(() => {
        safeStorage(window.sessionStorage, 'setItem', automaticSessionKey, '1');
      });
  };

  enableAutomaticLocalization();

  renderDisplayCurrencies();
  refreshCart(false).catch(() => {});
})();
